(function () {

    let filter = [];
    let currentUrl = new URL(window.location.href);
    let source = currentUrl.searchParams.get("source") || null;
    if (source) {
        source = source.replaceAll('_','');
        filter = source.split(' ');
    }


    /**
     * Фильтрует карточки
     */
    function filterCards(filter) {

        console.log(filter)

        // show/hide cards
        document.querySelectorAll('.tile-source')
                .forEach(function (card) {
                    let show = !filter.length;
                    if (filter.length) {
                        show = filter.includes(card.getAttribute('data-source'));
                    }
                    card.classList.toggle('tile-filtered', !show);
            });

        // show/hide category containers
        document.querySelectorAll('#species__index .articles-tiles')
                .forEach(function (category) {
                    let hiddenCount = category.querySelectorAll('.tile-filtered').length;
                    let totalCount = category.querySelectorAll('.tile-source').length;

                    category.classList.toggle('hidden', hiddenCount === totalCount);
                });

        let url = '/species/';
        if (filter.length) {
            url += '?source=' + filter.sort().join('+');
        }
        setCurrentPageUrl(url);
    }

    document.addEventListener('DOMContentLoaded', () => {

        filterCards(filter);

        document.querySelectorAll('.menu-filter-item').forEach(function (menuItem) {

            let filterValue = menuItem.getAttribute('data-filter')

            menuItem.addEventListener('click', function (event) {
                event.preventDefault();

                if ('all' === menuItem.getAttribute('data-filter')) {
                    filter = [];
                    document.querySelectorAll('.menu-filter-item.active')
                            .forEach((item)  => item.classList.remove('active'))
                } else {
                    if (menuItem.classList.contains('active')) {
                        menuItem.classList.remove('active')
                        filter = removeItemAll(filter, filterValue)
                    } else {
                        menuItem.classList.add('active')
                        filter.push(filterValue)
                    }

                }

                filterCards(filter);
            })

        })

        filter.forEach(function (filterItem) {
            document.querySelector(`[data-filter="${filterItem}"]`).classList.add('active');
        });
    });
})()